import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { whatsappUrl, trackWaClick } from "../lib/whatsapp";

const ease = [0.22, 1, 0.36, 1];

const WhatsAppGlyph = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.372-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347Z"/>
    <path d="M20.52 3.449C18.24 1.17 15.24 0 12.04 0 5.46 0 .14 5.32.14 11.9c0 2.09.54 4.13 1.57 5.94L.03 24l6.36-1.67a11.89 11.89 0 0 0 5.64 1.44h.01c6.58 0 11.9-5.32 11.9-11.9 0-3.18-1.26-6.16-3.42-8.42ZM12.04 21.8h-.01a9.88 9.88 0 0 1-5.03-1.38l-.36-.21-3.78 1 1.01-3.68-.24-.38A9.85 9.85 0 0 1 2.13 11.9C2.14 6.45 6.6 2 12.05 2c2.66 0 5.15 1.04 7.03 2.92a9.83 9.83 0 0 1 2.91 7.01c-.01 5.46-4.46 9.87-9.95 9.87Z"/>
  </svg>
);

export default function FinalCtaSection() {
  return (
    <section
      id="start-jetzt"
      className="relative py-24 sm:py-32 bg-brand-inverse text-brand-onInverse overflow-hidden grain"
      data-testid="final-cta-section"
    >
      {/* Ambient glows */}
      <div aria-hidden className="pointer-events-none absolute top-1/2 -translate-y-1/2 -left-40 w-[520px] h-[520px] rounded-full bg-brand-energy/25 blur-[120px]" />
      <div aria-hidden className="pointer-events-none absolute top-1/2 -translate-y-1/2 -right-40 w-[420px] h-[420px] rounded-full bg-brand-energy/15 blur-[120px]" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, ease }}
          className="text-[11px] font-bold tracking-[0.25em] uppercase"
          style={{ color: 'var(--brand-green-neon)' }}
        >
          Jetzt loslegen
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease, delay: 0.05 }}
          className="mt-4 font-heading text-5xl sm:text-6xl lg:text-7xl font-black tracking-[-0.035em] leading-[0.92]"
        >
          Bereit für dein<br />
          <span className="inline-block relative">
            <span className="relative z-10">24h-Angebot?</span>
            <span aria-hidden className="absolute left-0 bottom-2 w-full h-3" style={{ background: 'var(--brand-green-neon)', opacity: 0.3, zIndex: 0 }} />
          </span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease, delay: 0.12 }}
          className="mt-6 text-base sm:text-lg text-neutral-300 max-w-xl mx-auto leading-relaxed"
        >
          Ein Klick. Eine Nachricht. Ein Angebot innerhalb von 24 Stunden.<br />
          Kostenlos, unverbindlich, DSGVO-konform.
        </motion.p>

        <motion.a
          href={whatsappUrl()}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWaClick("final_cta")}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          whileHover={{ y: -3 }}
          whileTap={{ scale: 0.98 }}
          transition={{ duration: 0.6, ease, delay: 0.18 }}
          className="mt-10 inline-flex items-center justify-center gap-3 rounded-full py-5 px-8 sm:py-6 sm:px-10 text-lg sm:text-xl font-bold text-white shadow-[0_24px_60px_-12px_rgba(0,200,83,0.6)] transition-all"
          style={{ background: 'linear-gradient(135deg, #00C853 0%, #00E676 100%)' }}
          data-testid="final-whatsapp-cta"
        >
          <WhatsAppGlyph className="w-6 h-6" />
          Auf WhatsApp starten
          <ArrowUpRight className="w-5 h-5 arrow-shift" strokeWidth={2.4} />
        </motion.a>

        <p className="mt-6 text-xs text-neutral-500">
          Du wirst zu WhatsApp weitergeleitet. Keine Registrierung nötig.
        </p>
      </div>
    </section>
  );
}
